<template>
    <div>
        <div style="max-height: 130px; overflow-y: scroll;">
            <el-tag
                v-for="(tag, index) in value"
                :key="index"
                class="tag-item"
                :closable="!readOnly"
                :disable-transitions="false"
                @close="deleteTag(index)"
                :type="getTagType(tag)"
            >
                {{ tag }}
                <span v-if="getTagType(tag) === 'danger'" class="error-icon"></span>
            </el-tag>
        </div>
        <el-input
            v-if="!readOnly && (!maxLength || (value || []).length < maxLength)"
            v-model="input"
            class="input-new-tag"
            :placeholder="placeholder"
            :style="{ width: width }"
            @keyup.enter.native="addTag()"
        />
        <div v-if="errorMessage" class="error-message">
            {{ errorMessage }}
        </div>
    </div>
</template>

<script>
export default {
    name: 'TagInput',
    props: {
        value: {
            type: Array,
            default: () => []
        },
        width: {
            type: String,
            default: '80px'
        },
        maxLength: {
            type: Number,
            default: 500
        },
        readOnly: {
            type: Boolean,
            default: false
        },
        placeholder: {
            type: String,
            default: '回车添加'
        },
        validateType: {
            type: String,
            default: 'keyword', // 默认关键词验证（不验证）
            validator: function(value) {
                return ['package', 'keyword'].includes(value)
            }
        }
    },
    data() {
        return {
            input: '',
            errorMessage: ''
        }
    },
    methods: {
        deleteTag(index) {
            let val = [...this.value]
            val.splice(index, 1);
            this.$emit('input', val);
            this.clearError();
        },
        
        addTag() {
            let value = this.value || [];
            let input = this.input ? this.input.trim() : '';
            
            if (!input) return;
            
            input = input.replace(/，/g, ',').replace(/\s+/g, '');
            let val = input.split(',');
            
            let hasError = false;
            let newTags = [];
            
            val.forEach((v) => {
                if (!v) return;

                // 校验是否超过最大标签数量
                if (this.maxLength > 0 && value.length >= this.maxLength) {
                    this.errorMessage = `标签数量不能超过${this.maxLength}个`;
                    hasError = true;
                    return;
                }

                if (this.validateType === 'package') {
                    const validationResult = this.validatePackageName(v);
                    if (!validationResult.isValid) {
                        this.errorMessage = validationResult.message;
                        hasError = true;
                        return;
                    }
                }
                
                if (!value.includes(v) && !newTags.includes(v)) {
                    newTags.push(v);

                    // 检查添加后是否会超出最大数量
                    if (this.maxLength > 0 && (value.length + newTags.length) > this.maxLength) {
                        this.errorMessage = `标签数量不能超过${this.maxLength}个`;
                        hasError = true;
                        newTags.pop(); // 移除刚刚添加的标签
                        return;
                    }
                }
            });
            
            if (hasError) {
                return;
            }
            
            if (newTags.length > 0) {
                this.$emit('input', [...value, ...newTags]);
            }
            
            this.input = '';
            this.clearError();
        },
        
        validatePackageName(packageName) {
            // 规则1: 不能以数字开头
            if (/^[0-9]/.test(packageName)) {
                return {
                    isValid: false,
                    message: `包名"${packageName}"不能以数字开头`
                };
            }
            
            // 规则2: 必须包含点分隔，至少包含2段
            const segments = packageName.split('.');
            if (segments.length < 2) {
                return {
                    isValid: false,
                    message: `包名"${packageName}"必须包含点分隔，至少2段`
                };
            }
            
            // 规则3: 每段只能包含字母、数字、下划线，且不能为空
            for (let i = 0; i < segments.length; i++) {
                const segment = segments[i];
                
                if (!segment) {
                    return {
                        isValid: false,
                        message: `包名"${packageName}"的每段不能为空`
                    };
                }
                
                if (!/^[a-zA-Z0-9_-]+$/.test(segment)) {
                    return {
                        isValid: false,
                        message: `包名"${packageName}"的每段只能包含字母、数字和下划线`
                    };
                }
                
                // 第一段额外检查：不能以数字开头
                if (i === 0 && /^[0-9]/.test(segment)) {
                    return {
                        isValid: false,
                        message: `包名"${packageName}"的第一段不能以数字开头`
                    };
                }
            }
            
            return { isValid: true, message: '' };
        },
        
        getTagType(tag) {
            if (this.validateType === 'package') {
                const validation = this.validatePackageName(tag);
                return validation.isValid ? 'success' : 'danger';
            }
            return 'primary';
        },
        
        clearError() {
            this.errorMessage = '';
        }
    },
    
    watch: {
        input() {
            if (this.errorMessage) {
                this.clearError();
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.tag-item {
    margin-right: 5px;
    margin-bottom: 5px;
}

.input-new-tag {
    margin-bottom: 5px;
}

.error-message {
    color: #f56c6c;
    font-size: 12px;
    margin-top: 4px;
}

.error-icon {
    margin-left: 4px;
    font-size: 12px;
}
</style>